import { render } from "./PersonalPortfolio.vue?vue&type=template&id=52e506df"
import script from "./PersonalPortfolio.vue?vue&type=script&lang=js"
export * from "./PersonalPortfolio.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gokaysen/Desktop/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__